import {
  Locale,
  SupportedLocaleCodes,
} from '@libs/src/locale/locale.interface';

import includes from 'lodash-es/includes';

const localeCodes = { enUS: 'en-US', frCA: 'fr-CA', ko: 'ko' };
export const defaultLocaleCode = localeCodes.enUS;

export const locales: Locale[] = [
  {
    code: localeCodes.enUS,
    name: $localize`:@@global.localeEnUS:English (US)`,
  },
  {
    code: localeCodes.frCA,
    name: $localize`:@@global.localeFrCA:French (Canada)`,
  },
  {
    beta: true,
    code: localeCodes.ko,
    name: $localize`:@@global.localeKo:Korean`,
  },
];

export const defaultLocale = locales.find(
  (locale) => locale.code === defaultLocaleCode,
);

export function isSupportedLocale(localeCode: string): boolean {
  return includes(SupportedLocaleCodes, localeCode);
}

export function getLocaleName(localeCode: typeof SupportedLocaleCodes[number]) {
  return locales.find((locale) => locale.code === localeCode).name;
}
